// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

const initialMeliUsers = () => {
    if (typeof window !== 'undefined') {
        const item = window.localStorage.getItem('meliUsers')
        return item ? JSON.parse(item) : []
    }
    return []
}

const initialDefaultMeliUserId = () => {
    if (typeof window !== 'undefined') {
        return window.localStorage.getItem('defaultMeliUserId') || null
    }
    return null
}

export const meliSlice = createSlice({
    name: 'mercadolibre',
    initialState: {
        meliUsers: initialMeliUsers(), // Array de usuarios de MercadoLibre
        defaultMeliUserId: initialDefaultMeliUserId(), // ID del usuario por defecto
        isLoading: false,
        error: null
    },
    reducers: {
        setMeliUsers: (state, action) => {
            state.meliUsers = action.payload
            state.isLoading = false
            state.error = null


            // Guardar en localStorage una versión sin access_token
                const sanitizedUsers = action.payload.map(user => {
                const { access_token: AccessToken, ...rest } = user
                return rest
            })
            localStorage.setItem('meliUsers', JSON.stringify(sanitizedUsers))

            // Establecer usuario por defecto si no existe
            if (!state.defaultMeliUserId && action.payload.length > 0) {
                state.defaultMeliUserId = action.payload[0].meliuserid.toString()
                localStorage.setItem('defaultMeliUserId', state.defaultMeliUserId)
            }
        },

        setDefaultMeliUserId: (state, action) => {
            state.defaultMeliUserId = action.payload.toString()
            localStorage.setItem('defaultMeliUserId', action.payload.toString())
        },

        setLoading: (state, action) => {
            state.isLoading = action.payload
        },

        setError: (state, action) => {
            state.error = action.payload
            state.isLoading = false
        },

        clearMeliData: (state) => {
            state.meliUsers = []
            state.defaultMeliUserId = null
            state.isLoading = false
            state.error = null

            localStorage.removeItem('meliUsers')
            localStorage.removeItem('defaultMeliUserId')
        }
    }
})

export const {
    setMeliUsers,
    setDefaultMeliUserId,
    setLoading,
    setError,
    clearMeliData
} = meliSlice.actions

export default meliSlice.reducer